'use strict';

namespace Core {

    class CheckboxPopup {
        public checked: boolean = false;
        public labelText: string;
        public popupMessageText: string;
        public popupHeaderText: string;

        private getPopupHeaderText: () => string;
        private getPopupMessageText: () => string;
        private getLabelText: () => string;

        static getEventData() {
            return {
                label: 'Hotel for only part of Holiday',
                category: 'Search Bar',
                action: 'Click',
                value: 1
            };
        }

        constructor (
            private analytics: any,
            private $route: ng.route.IRouteService
        ) {}

        $onInit(): void {
            this.labelText = this.getLabelText();
            this.popupMessageText = this.getPopupMessageText();
            this.popupHeaderText = this.getPopupHeaderText();
        }

        public closePopup() {
            this.checked = false;
        }

        private getCurrentRouteLabel() {
            return _.get(this.$route, 'current.$$route.pixelTrackingPageName');
        }

        public checkboxClick() {
            let eventData = CheckboxPopup.getEventData();
            const currentRouteName = this.getCurrentRouteLabel();
            if (currentRouteName) {
                eventData.category = `${eventData.category} ${currentRouteName}`;
            }

          this.analytics.trackEvent(eventData);
        }
    }

    angular
        .module('core')
        .directive('checkboxPopup', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: CheckboxPopup,
                controllerAs: 'checkboxPopupCtrl',
                bindToController: {
                    getLabelText: '&',
                    getPopupHeaderText: '&',
                    getPopupMessageText: '&'
                },
                template: `
                    <lightbox 
                        show="checkboxPopupCtrl.checked"
                        close="checkboxPopupCtrl.closePopup()"
                        header-text="checkboxPopupCtrl.popupHeaderText"
                        lightbox-class="lightbox-checkbox-popup"
                        >
                        <div class="message-container">
                            <span ng-bind-html="checkboxPopupCtrl.popupMessageText"></span>
                            <button ng-click="checkboxPopupCtrl.closePopup()">OK</button>
                        </div>
                    </lightbox>
                    <div class="checkbox-popup-container">
                        <checkbox 
                            model="checkboxPopupCtrl.checked"
                            on-click="checkboxPopupCtrl.checkboxClick()"
                            >
                            {{checkboxPopupCtrl.labelText}}
                        </checkbox>
                    </div>
                `
            };
        });
}
